module.exports = __webpack_public_path__ + "static/media/belle.12066cef.png";